import { LucideSearch, PhoneCall } from 'lucide-react';
import React from 'react'
import {Link,  useNavigate } from 'react-router-dom';
import TypeWriter from './TypeWriter';
const TypeWriterHeroSection = ({phoneNumber}) => {
const navigate = useNavigate();
  return (
    <section
  className="homePageUsp py-16 sm:py-16 md:py-16 lg:py-16 bg-cover bg-center bg-no-repeat min-h-[450px] sm:min-h-[500px] lg:min-h-[450px] flex items-center">
  <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 sm:gap-12">
      {/* Left Content */}
      <div className="text-left">
        <h1 className="text-3xl md:text-5xl lg:text-5xl lg:leading-normal font-medium text-white mb-2">
                Power your Project with
              </h1>
              <h2 className="text-3xl md:text-5xl lg:text-5xl lg:leading-normal font-bold text-white mb-6">Right{' '}<TypeWriter
                  words={[
                    "Forklift?",
                    "Telehandler?",
                    "Excavator?",
                    "Skid Steer?",
                    "Mini Excavator?",
                  ]}
                  className="font-semibold"
                />
              </h2>

        <p className="text-xl sm:text-base md:text-lg lg:text-xl text-white max-w-2xl leading-relaxed">
          Shortlisted by industry experts with 17+ years of experience.
          Customized solutions for every project.
        </p>
      </div>

      {/* Right Buttons */}
      <div className="flex flex-col gap-4 sm:gap-8 w-full sm:w-auto items-start">
        <button
          className="gradient-btn"
          onClick={() => {
            window.location.href = `tel:${phoneNumber}`;
          }}
        >
          <div className="gradient-btn-content flex items-center justify-center">
            <PhoneCall className="w-4 h-4 mr-3" />
            <span>Enquire Now</span>
          </div>
        </button>
        <button
          className="secondary-gradient-btn"
          onClick={() => navigate("/products?taxonomy=equipment-buy")}
        >
          <div className="secondary-gradient-btn-content flex items-center justify-center">
            <LucideSearch className="w-4 h-4 mr-3" />
            <span>Browse Inventory</span>
          </div>
        </button>
        
      </div>
    </div>
  </div>

  <style jsx>{`

    .homePageUsp{
      background-image: url(images/homePage/homeBnaner2.webp);
    }

    .homePageUsp .secondary-gradient-btn-content,
    .homePageUsp .gradient-btn-content {
      width: 325px !important;
    }

    @media screen and (max-width:640px){
    .homePageUsp{
      background-image: url(images/homePage/homeBnaner2Mob.webp);
    }
    
    }
  `}</style>
</section>
  )
}

export default TypeWriterHeroSection